import React, { useState } from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Field, getIn } from 'formik';
import AsyncSelect from 'react-select/async';
import classNames from 'classnames';

function FormAsyncSelectFieldInner(props) {
  const {
    label,
    placeholder,
    form,
    field,
    onChangeHandler,
    loadOptions,
    defaultOptions,
    onInputChange = () => {},
    loadRightAway,
    disabled,
    required = false,
  } = props;

  const [isActiveFetchData, setActiveFetchData] = useState(loadRightAway);

  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);
  const value = getIn(form.values, field.name, '');

  const onFocusHandler = () => {
    setActiveFetchData(true);
  };

  const hasValue = Boolean(
    value && (value.postcode || value.label || value.id || value.value),
  );
  const valueSelect = hasValue
    ? {
        label: value?.postcode || value?.label,
        value: value?.id || value?.value,
      }
    : null;

  const loadOneOption = (inputValue, callback) => {
    if (!valueSelect?.label) {
      callback(false);
      return false;
    }

    callback([
      {
        label: String(valueSelect.label),
        value: valueSelect.value,
      },
    ]);
    return true;
  };

  const getErrorMessage = (error) => {
    if (typeof error === 'object' && error !== null) {
      if (error.value !== undefined) {
        return String(error.value);
      }
      return JSON.stringify(error);
    }
    return String(error);
  };

  const handleAsyncSelectChange = (form, fieldName, option, onChangeHandler) => {
    if (option && typeof option === 'object') {
      const sanitizedOption = {
        ...option,
        label:
          typeof option.label === 'object'
            ? JSON.stringify(option.label)
            : String(option.label || ''),
        value: option.value || '',
      };
      form.setFieldValue(fieldName, sanitizedOption);
      onChangeHandler?.(sanitizedOption);
    } else if (option === null) {
      form.setFieldValue(fieldName, { value: '', label: '' });
      onChangeHandler?.(null);
    } else {
      form.setFieldValue(fieldName, option);
      onChangeHandler?.(option);
    }
  };

  return (
    <Row className="mb-3">
      <Col>
        <FormLabel className={classNames(required && 'label-required')}>{label}</FormLabel>
        <FormGroup>
          <AsyncSelect
            loadOptions={isActiveFetchData ? loadOptions : loadOneOption}
            defaultOptions={defaultOptions}
            placeholder={placeholder}
            value={valueSelect}
            isDisabled={form.isSubmitting || disabled}
            onBlur={() => form.setFieldTouched(field.name, true)}
            onInputChange={onInputChange}
            onChange={(option) =>
              handleAsyncSelectChange(form, field.name, option, onChangeHandler)
            }
            onFocus={onFocusHandler}
            className="async-select"
            classNamePrefix="async-select"
            isClearable={!!valueSelect}
          />
          {(form.submitCount > 0 || touched) && error && (
            <label
              style={{
                display: 'block',
                color: 'red',
                marginTop: 6,
                letterSpacing: '0.02rem',
                fontSize: 13,
              }}
            >
              {getErrorMessage(error)}
            </label>
          )}
        </FormGroup>
      </Col>
    </Row>
  );
}

function FormAsyncSelectField(props) {
  return <Field {...props} component={FormAsyncSelectFieldInner} />;
}

FormAsyncSelectField.defaultProps = {
  placeholder: '',
  options: [],
  onChangeHandler: () => {},
  loadRightAway: true,
  disabled: false,
};

FormAsyncSelectField.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  onChangeHandler: PropTypes.func,
  loadRightAway: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default FormAsyncSelectField;
